import { ReportingDayRange } from '../../../../store/features/reportingDashboard/reportingDashboardSlice';

export const getDescriptiveRangeLabels = (
    range: ReportingDayRange,
    t: (key: string) => string
): { previous: string; current: string } => {
    if (range === 'custom') {
        return {
            previous: t('ReportingDashboard_PreviousCustomRange'),
            current: t('ReportingDashboard_CurrentCustomRange'),
        };
    }

    const rangeStr = range.toString();

    const prevRangeLabel =
        range > 1
            ? t('ReportingDashboard_PreviousNDays').replace('{count}', rangeStr)
            : t('ReportingDashboard_PreviousDay');

    const currRangeLabel =
        range > 1
            ? t('ReportingDashboard_CurrentNDays').replace('{count}', rangeStr)
            : t('ReportingDashboard_CurrentDay');

    return {
        previous: prevRangeLabel,
        current: currRangeLabel,
    };
};
